var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHomeBase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 32,
    height: 32,
    fill: "#00c4de"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M3.5,32A3.5,3.5,0,0,1,0,28.5V3.5A3.5,3.5,0,0,1,3.5,0h17A3.5,3.5,0,0,1,24,3.5v25a3.448,3.448,0,0,1-.036.5H28.5a.5.5,0,0,0,.5-.5V16.57a.5.5,0,0,0-.222-.416l-2.11-1.406a1.5,1.5,0,0,1,1.664-2.5l2.11,1.406A3.5,3.5,0,0,1,32,16.57V28.5A3.5,3.5,0,0,1,28.5,32h-7a1.6,1.6,0,0,1-.394-.052A3.5,3.5,0,0,1,20.5,32h-6A1.5,1.5,0,0,1,13,30.5V28H11v2.5A1.5,1.5,0,0,1,9.5,32ZM3,28.5a.5.5,0,0,0,.5.5H8V26.5A1.5,1.5,0,0,1,9.5,25h5A1.5,1.5,0,0,1,16,26.5V29h4.5a.5.5,0,0,0,.5-.5V3.5a.5.5,0,0,0-.5-.5H3.5a.5.5,0,0,0-.5.5ZM7.5,12h1a1.5,1.5,0,1,1,0,3h-1a1.5,1.5,0,0,1,0-3ZM6,7.5A1.5,1.5,0,0,1,7.5,6h1a1.5,1.5,0,1,1,0,3h-1A1.5,1.5,0,0,1,6,7.5Zm8,6A1.5,1.5,0,0,1,15.5,12h1a1.5,1.5,0,0,1,0,3h-1A1.5,1.5,0,0,1,14,13.5ZM15.5,6h1a1.5,1.5,0,0,1,0,3h-1a1.5,1.5,0,0,1,0-3ZM6,19.5A1.5,1.5,0,0,1,7.5,18h1a1.5,1.5,0,0,1,0,3h-1A1.5,1.5,0,0,1,6,19.5ZM15.5,18h1a1.5,1.5,0,0,1,0,3h-1a1.5,1.5,0,0,1,0-3Z",
    fill: "#00c4de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeBase);
export default __webpack_public_path__ + "static/media/Icon_homeBase.1e9983f6343b0d3a764e8b7a894f4107.svg";
export { ForwardRef as ReactComponent };